import { ISupplierChangeType } from "models/CSDIntegration/CSDIntegrationModel";
import { BaseService } from "./base.service";

class SupplierChangeTypeServiceInternal extends BaseService {
	getSupplierChangeTypeList = async (): Promise<ISupplierChangeType[]> =>
		this.callApi<ISupplierChangeType[]>(
			`SupplierChangeType/GetSupplierChangeTypeList`,
			"GET"
		);
}

export const SupplierChangeTypeService =
	new SupplierChangeTypeServiceInternal();
